import actions from './actions';

const {
  SPL_DASHBOARD_DATA_BEGIN,
  SPL_DASHBOARD_DATA_SUCCESS,
  SPL_DASHBOARD_DATA_ERR,
} = actions;

const initialState = { data: [], loading: false, error: null };

export const splDashboardReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case SPL_DASHBOARD_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case SPL_DASHBOARD_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case SPL_DASHBOARD_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};
